export default __webpack_public_path__ + "static/media/install-widget.8653249f.svg";